export const SET_ZOOM_ANIM: String = 'SET_ZOOM_ANIM';
export const RESET_ZOOM_ANIM: String = 'RESET_ZOOM_ANIM';

export interface ZoomDataAnim {
    value: number
}

export interface ZoomAnimAction {
    type: typeof SET_ZOOM_ANIM,
    payload: ZoomDataAnim
}

export const setZoomAnimAction = (payload: ZoomDataAnim): ZoomAnimAction => {
    return {
        type: SET_ZOOM_ANIM,
        payload
    }
}

export const ResetZoomAction = () => {
    return {
        type: RESET_ZOOM_ANIM
    }
}